const IconColors = {
  blue: '#1677ff',
  green: '#00A499',
  lime: 'rgb(160, 200,100)',
  lilac: 'rgb(205, 90, 155)',
  red: '#ff4d4f',
  bigaro: 'rgb(150, 125, 185)',
  gray: '#5a5a5a',
};

export default IconColors;
